module.exports = __webpack_public_path__ + "img/logoOne.1e3f1b25.png";